// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"99c129d6","430":"6b2ef2f4","795":"a48fa5f9"}[chunkId] + ".chunk.js";
};